import { render, staticRenderFns } from "./CreateCustomBlock.vue?vue&type=template&id=6d52231a&"
import script from "./CreateCustomBlock.vue?vue&type=script&lang=js&"
export * from "./CreateCustomBlock.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomBlock.vue?vue&type=style&index=0&id=6d52231a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports